<template>
  <div class="childtrackingsystem-forms">
    <div v-if="!isContent" class="row row-cols-auto align-items-center bg-white py-3">
        <label class="col col-form-label fw-bold">Kinderen</label>
        <div class="col">
            <select id="childrenselect"
                    class="form-select form-select-sm"
                    @change="childSelect($event)"
            >
                <option value="0">Alle</option>
                <option
                    v-for="child in childrenCTS"
                    :key="child.id"
                    :value="child.id"
                >{{ child.name }}</option>
            </select>
        </div>
        <div class="col ms-auto">
            <button
                class="btn btn-outline-danger"
                @click="changeOverview(false)"
                v-if="showActive"
            >Ga naar archief
            </button>
            <button
                class="btn btn-outline-success"
                @click="changeOverview(true)"
                v-if="!showActive"
            >Verlaat archief
            </button>
        </div>
    </div>

    <div v-if="!isContent" class="row bg-white">
      <div class="col-12">
        <table class="table">
            <thead>
                <tr>
                    <th>Observatieformulier</th>
                    <th class="text-end pe-1">
                        <span
                            data-bs-toggle="modal"
                            data-bs-target="#infoModal"
                        ><icon name="info"></icon>
                        </span>
                    </th>
                </tr>
            </thead>
          <tbody>
              <tr v-bind:key="key" v-for="(form, key) in forms">
                  <td>
                      <span class="fw-bold">{{form.listTitle}}</span> van kind <span class="fw-bold">{{ form.childName }}</span>
                      ({{form.childAge}}) opgeslagen op {{ form.date }}
                      <span v-if="viewStatus">(status: {{ form.status }})</span>
                  </td>
                  <td class="text-end pe-1" style="width:120px;">
                      <span
                          style="margin-top: 5px; margin-right: 15px;color:#666;"
                          title="Bekijk"
                          @click="openChildForm(form.idResult, form.idChildForm)"
                      >
                        <icon name="look-into"></icon>
                      </span>
                      <span
                          style="margin-top: 5px; margin-right: 15px;"
                          title="Print naar pdf"
                          @click="printChildForm(form.idChildForm);"
                      >
                          <icon name="file-pdf"></icon>
                      </span>
                  </td>
              </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modalLoader" v-if="isLoading">
      <img src="../../assets/img/loading.gif" style="width: 80px; height: 80px;" alt="Loading"/>
    </div>

    <div v-if="isContent">
      <childtrackingsystem-observationform :idResult="selectedResult" :idChildForm="selectedChildForm"></childtrackingsystem-observationform>
    </div>

      <div
          class="modal fade"
          id="infoModal"
          tabindex="-1"
          aria-hidden="true"
      >
          <div class="modal-dialog">
              <div class="modal-content">
                  <div class="modal-header">
                      <button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                      ></button>
                  </div>
                  <div class="modal-body">
                      <div class="row">
                          <div class="col-3">
                              <icon name="look-into"></icon>
                          </div>
                          <div class="col-9">Bekijk observatieformulier</div>
                      </div>
                      <div class="row">
                          <div class="col-3">
                              <icon name="file-pdf"></icon>
                          </div>
                          <div class="col-9">Print observatieformulier</div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

  </div>
</template>

<script>
import ChildtrackingsystemObservationform from "./ObservationForm";
import icon from "@/components/Icon.vue";
export default {
  name: 'childtrackingsystem-forms',
  components: {icon, ChildtrackingsystemObservationform},
  props: [],
  data() {
    return {
      isContent: false,
      isLoading: false,
      childId: null,
      listId: null,
      formId: null,
      resultId: null,
      forms: [],
      childrenCTS: [],
      showActive: true,
      isModalInfo: false,
      viewStatus: true,
      selectedResult: 0,
      selectedChildForm: 0
    }
  },
  computed: {
    deviceToken() {
      return this.$store.getters.deviceToken
    },
    session() {
      return this.$store.getters.session
    },
  },
  created() {
    window.novict = {
      device: {
        device_token: this.deviceToken
      },
      session: {
        session_token: this.session.session_token
      }
    }
    this.showActive = true
    this.getChildObservationForms()
  },
  methods: {
    getChildObservationForms() {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      this.$request.post('/ChildTrackingSystem/forms', {
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        selectedChild: this.childId,
        showActive: this.showActive
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response.forms) {
          this.forms = response.forms
          this.childrenCTS = response.children
          this.showActive = response.showActive
          this.viewStatus = response.viewStatus
          this.isLoading = false
        }
      })
    },
    changeOverview (status) {
      this.showActive = status
      this.getChildObservationForms()
    },
    formatDate(date) {
      return this.$moment(date).format('DD-MM-YYYY')
    },
    viewContent(childId, listId, idResult, formId) {
      this.isContent = true
      this.resultId = idResult
      this.childId = childId
      this.listId = listId
      this.formId = formId
    },
    printChildForm(idChildForm, childId, listId, idResult, formId) {
      this.isLoading = true
      this.$store.commit('REGISTER_ACTIVE_REQUEST')
      this.$request.post('/ChildTrackingSystem/downloadChildForm', {
        idChildForm: idChildForm,
        idForm: formId,
        idChild: childId,
        idList: listId,
        idResult: idResult,
        idEstablishment: this.$store.getters.selectedEstablishment.id,
        idGroup: this.$store.getters.selectedGroupsQueryString,
        answerOption: 'last'
      }).then((response) => {
        this.$store.commit('REMOVE_ACTIVE_REQUEST')
        if (response) {
            this.download(response.filename, response.fileContent)
        } else {
            this.isLoading = false
        }
      })
    },
      download(filename, fileContent) {
          var docUrl = document.createElement('a')
          docUrl.href = "data:application/octet-stream;base64," + fileContent
          docUrl.setAttribute('download', filename)
          document.body.appendChild(docUrl)
          docUrl.click()
          this.isLoading = false
      },
    childSelect(event) {
      this.childId = event.target.value
      this.getChildObservationForms()
      return event.target.value
    },
    closeModal() {
      this.isModalInfo = false
    },
    seeLegenda() {
      this.isModalInfo = true
    },
    openChildForm(idResult, idChildForm) {
      this.isContent = true
      this.selectedResult = idResult
      this.selectedChildForm = idChildForm
    }
  }
}
</script>

<style scoped>
.modalLoader {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 100px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.table {
  width: 100%;
}

.table th {
  color: #666;
  background-color: #f0f0f5;
  border-top: 1px solid #ddd !important;
}

.table td {
  border-bottom: 1px solid #ddd !important;
  color: #666;
}
</style>
